'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (typeof Reflect === 'object' && typeof Reflect.ownKeys === 'function') {
		return Reflect.ownKeys;
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/reflect.ownkeys/polyfill.js
// module id = 1022
// module chunks = 2